import React from 'react';
import { useLanguageCode } from './TranslationContext';
import { Helmet } from 'react-helmet';
export const HelmetTranslationProvider = ({ children }) => {
    const [languageCode] = useLanguageCode();
    if (languageCode)
        return (React.createElement(React.Fragment, null,
            React.createElement(Helmet, null,
                React.createElement("html", { lang: languageCode }),
                React.createElement("link", { rel: "canonical", href: window.location.origin + window.location.pathname })),
            children));
    else
        return null;
};
//# sourceMappingURL=HelmetTranslationProvider.js.map